import React, { useMemo } from 'react';
import NoApplicants from '../../../images/no-applicants.svg';
import NoClients from '../../../images/no-clients.svg';
import NotRequired from '../../../images/not-required.png';
import './no-grid-data.scss';
export var NoGridData = function (_a) {
    var image = _a.image, message = _a.message, description = _a.description, _ImageComponent = _a.ImageComponent;
    var ImageRendererer = function (_a) {
        var _imageSrc = _a.imageSrc;
        return (React.createElement("img", { src: _imageSrc, className: description && description.length > 0 ? 'c-grid-not-required__image' : 'c-grid-no-data__image', alt: "no-data" }));
    };
    var imageSrcObj = {
        'no-applicants': React.createElement(ImageRendererer, { imageSrc: NoApplicants }),
        'no-clients': React.createElement(ImageRendererer, { imageSrc: NoClients }),
        'not-required': React.createElement(ImageRendererer, { imageSrc: NotRequired }),
        'no-image': React.createElement(React.Fragment, null),
    };
    var ImageComponent = useMemo(function () {
        return imageSrcObj[image];
    }, [_ImageComponent, image, description]);
    return (React.createElement("div", { className: description && description.length > 0 ? 'c-grid-not-required' : 'c-grid-no-data' },
        ImageComponent,
        description && description.length > 0 ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "c-grid-not-required__message c-grid-shell-format" }, message),
            React.createElement("div", { className: "c-grid-not-required__description c-grid-shell-format" }, description))) : (React.createElement("div", { className: "c-grid-no-data__message" }, message))));
};
